<template>
  <div v-if="showDialog" class="dialog-overlay">
    <transition>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="mdi icon-config" :class="iconReturnConfig"></i>
          <span v-if="typeNotify === 'error'" class="header-config">Ops...</span>
          <span v-else class="header-config">{{ $_t('sucesso_tudo_pronto') }}</span>
        </div>
        <div class="dialog-body">
          <span>{{ message }}</span>
        </div>
        <div class="dialog-footer">
          <button @click="hideDialog" class="ok-btn">OK</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SessionService from "@/services/Session/Session.service";
import router from "@/plugins/router/index";

export default {
  data() {
    return {
      showDialog: false,
      message: '',
      typeNotify: 'success',
      property: null,
    };
  },

  computed: {
    iconReturnConfig() {
      return this.typeNotify === 'success' ? 'success-icon icon-success-color' : 'error-icon icon-error-color';
    }
  },

  methods: {
    show(message, typeNotify, property = null) {
      this.showDialog = true;
      this.message = message;
      this.typeNotify = typeNotify;
      this.property = property;
    },
    hideDialog(emitName, emit) {
      if (emitName, emit) {
        this.$emit(emitName, emit);
      }

      if (this.property === 'logout') {
        SessionService.destroy();
        router.push({ name: "Login" });
      } else if (this.property === 'onboard-perfil') {
        router.push({ name: "Perfil" });
      }

      this.resetDialogProps();
    },
    resetDialogProps() {
      this.showDialog = false;
      this.message = '';
      this.typeNotify = 'success';
      this.property = null;
    }
  },
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-container {
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  max-width: 600px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  text-align: center;
  font-family: 'Arial', sans-serif;
}

.dialog-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header-config {
  color: #595959;
  font-size: 30px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}

.dialog-body {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  margin-top: 0;
}

.dialog-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.ok-btn {
  background-color: black;
  color: #00E300;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.icon-config {
  width: 48px;
  height: 48px;
}

.ok-btn:hover {
  background-color: #494848;
}
</style>